/*
 *   File : upload-products.js
 *   Author : https://evoqins.com
 *   Description : Upload product modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';

// Custom component 
import { PrimaryButton, SecondaryButton, TextButton } from '../Buttons';
import { Icon } from '../Icon';
import { CustomFileUpload, CustomSelectBox, CustomTextInput } from '../FormElements';
import { APIService, AWSService } from '../../Service';
import { toast } from 'react-toastify';


const INNOVATION = [
    { value: "Innovation", label: "Innovation" },
    { value: "Old", label: "Old" },
];

const TYPE = [
    { value: "Smooth", label: "Smooth" },
    { value: "Under coasts", label: "Under coasts" },
    { value: "Special Effects", label: "Special Effects" },
    { value: "Textures", label: "Textures" },
];

const CATEGORY = [
    { value: "Medium", label: "Medium" },
    { value: "Premium", label: "Premium" },
];

const ManageProductModal = (props) => {

    const [file, setFile] = useState(null);
    const [fileName, setFileName] = useState(null);

    const [name, setName] = useState("");
    const [nameError, setNameError] = useState();
    const [code, setCode] = useState("");
    const [codeError, setCodeError] = useState("");

    const [point, setPoint] = useState(null);
    const [pointError, setPointError] = useState("");
    const [fileLoader, setFileLoader] = useState(false);

    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCategoryError, setSelectedCategoryError] = useState("");

    const [selectedInnovation, setSelectedInnovation] = useState(null);
    const [selectedInnovationError, setSelectedInnovationError] = useState("");

    const [selectedType, setSelectedType] = useState(null);
    const [selectedTypeError, setSelectedTypeError] = useState("");

    const [selectedPremium, setSelectedPremium] = useState(null);
    const [selectedPremiumError, setSelectedPremiumError] = useState("");

    const [size, setSize] = useState(null);
    const [sizeError, setSizeError] = useState("");

    const [sizeUnit, setSizeUnit] = useState(null);
    const [sizeUnitError, setSizeUnitError] = useState("");


    useEffect(() => {
        setNameError("");
    }, [name]);

    useEffect(() => {
        setCodeError("");
    }, [code]);

    useEffect(() => {
        setPointError("");
    }, [point]);

    useEffect(() => {
        setSelectedCategoryError("");
    }, [selectedCategory]);

    useEffect(() => {
        setSelectedInnovationError("");
    }, [selectedInnovation]);

    useEffect(() => {
        setSelectedTypeError("");
    }, [selectedType]);

    useEffect(() => {
        setSelectedPremiumError("");
    }, [selectedPremium]);

    useEffect(() => {
        setSizeError("");
    }, [size]);


    useEffect(() => {
        setSizeUnitError("");
    }, [sizeUnit]);

    useEffect(() => {
        if (props.status === true) {
            _handleSuccess();
        }
    }, [props.status]);

    useEffect(() => {
        if (props.editData && Object.keys(props.editData).length !== 0) {
            setName(props.editData.name);
            setCode(props.editData.item_code);
            setPoint(props.editData.points);
            setSize(props.editData.size);
            setSizeUnit(props.editData.size_text);

            if (props.editData.category_id !== null) {
                setSelectedCategory({ value: props.editData.category_id, label: props.editData.interior_exterior })
            }

            if (props.editData.innovation !== null) {
                setSelectedInnovation({ value: props.editData.innovation, label: props.editData.innovation })
            }

            if (props.editData.type !== null) {
                setSelectedType({ value: props.editData.type, label: props.editData.type })
            }

            if (props.editData.category !== null) {
                setSelectedPremium({ value: props.editData.category, label: props.editData.category })
            }

        }
    }, [props.editData]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("upload-product-modal-close");
        button.click();
        props.handleClose();
    };

    // handle close modal
    const _handleSuccess = () => {
        var button = document.getElementById("upload-product-modal-close");
        button.click();
        props.handleSuccess();
    };


    // handle upload file
    const _handleChangeUpload = (url) => {
        _getPresignedUrl(url);
    };

    const _handleSubmit = () => {
        let is_valid = true;

        if (props.type === 1) {

            if (file !== null) {
                props.handleSubmit(file);
            }

        } else {

            if (name.trim().length === 0) {
                setNameError("Please provide product name");
                is_valid = false;
            }
            if (code.trim().length === 0) {
                setCodeError("Please provide product code");
                is_valid = false;
            }
            if (point === null || point === "" || point === "-") {
                setPointError("Please provide product point");
                is_valid = false;
            }

            if (selectedCategory === null) {
                setSelectedCategoryError("Please provide category");
                is_valid = false;
            }

            if (selectedPremium === null) {
                setSelectedPremiumError("Please provide category");
                is_valid = false;
            }

            if (selectedType === null) {
                setSelectedTypeError("Please provide type");
                is_valid = false;
            }

            if (selectedInnovation === null) {
                setSelectedInnovationError("Please provide innovation/old");
                is_valid = false;
            }

            if (size === null || size === "" || size === "-") {
                setSizeError("Please provide size");
                is_valid = false;
            }

            // if (sizeUnit.trim().length === 0) {
            //     setSizeUnitError("Please provide size text");
            //     is_valid = false;
            // }

            if (is_valid === true) {

                let data = {
                    product_id: props.editData.id,
                    product_name: name,
                    product_code: code,
                    product_point: point,
                    product_category: selectedCategory?.value || null,

                    category: selectedPremium?.label || null,
                    type: selectedType?.label || null,
                    innovation: selectedInnovation?.label || null,
                    size: size,
                    size_text: sizeUnit
                }

                props.handleSubmit(data);
            }
        }
    };


    // get presigned url
    async function _getPresignedUrl(file) {
        setFileLoader(true);

        let is_post = true;
        let url = 'general/file-upload';
        let data = {
            "file": file.name,
            "is_public": true
        };
        try {
            let response = await APIService(is_post, url, data);
            if (response.status_code == 200) {
                let aws_fields = response.data.upload_info.fields;
                let aws_url = response.data.upload_info.url;

                try {
                    let aws_response = await AWSService(aws_fields, file, aws_url);
                    if (aws_response.status == 'ok') {
                        setFile(response.data.view_info);
                        setFileName(file.name);
                    } else {
                        toast.dismiss();
                        toast.error(aws_response.message, {
                            type: "error",
                            className: "e-toast",
                        });
                    }
                } catch (err) {
                    console.log("error")
                }
            } else {
                toast.dismiss();
                toast.error(response.message, {
                    type: "error",
                    className: "e-toast",
                });
            }
        } catch (err) {
        }
        setFileLoader(false);
    };

    return (
        <div className="modal fade" id="upload-product-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="approveRequestModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered e-border-radius-24 modal-dialog-scrollable">
                <div className="modal-content e-border-radius-8">
                    <div className="modal-header px-4 pt-4 pb-1 border-0 align-items-start">
                        <div>
                            <h4 className="mb-0 e-primary-font-playfair e-text-dark-jungle-green e-font-18 e-font-weight-500 line-height-28px">
                                {props.title}
                            </h4>
                            <p className='mb-0 e-alt-font-noto-sans e-text-davys-grey e-font-14 e-font-weight-400 line-height-20px'>
                                {props.description}
                            </p>
                        </div>
                        <Icon icon="close-icon"
                            className='cursor-pointer'
                            size="24px"
                            onPress={_handleCloseModal} />
                        <button type="button" id='upload-product-modal-close' className="btn-close shadow-none d-none" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body px-4 pb-0 pt-3 e-scroll">
                        {props.type === 1 ?
                            <>
                                <div className='e-bg-alice-blue-dark e-border-radius-16 p-3 mb-3'>
                                    <p className='mb-0 e-text-davys-grey e-alt-font-noto-sans e-font-12 e-font-weight-400 line-height-16px'>
                                        Use the upload option to update data. Only .csv or .xls files are supported.
                                    </p>
                                </div>

                                <CustomFileUpload
                                    placeholder="Drop your file here"
                                    file={fileName}
                                    fileType={["xls", "csv", "xlsx"]}
                                    type={3}
                                    require
                                    loader={fileLoader}
                                    support="xls,csv,xlsx"
                                    // loader={thumbnailLoader}
                                    handleChange={_handleChangeUpload}
                                />

                                {/* change thumbnail button */}
                                <div className={`${file === null ? "invisible" : "visible"} mb-2 margin-neg-16px-top text-end pe-1`}>
                                    <TextButton name="Clear"
                                        onPress={() => {
                                            setFile(null);
                                            setFileName(null);
                                        }} />
                                </div>
                            </>
                            :
                            <>
                                {/* Product name */}
                                <CustomTextInput label="Product name"
                                    placeholder="Jotashield Nuovo"
                                    type="text"
                                    require
                                    value={name}
                                    error={nameError}
                                    className="w-100"
                                    labelStyle="e-font-weight-500 e-text-raisin-black"
                                    onKeyPress={_handleSubmit}
                                    handleChange={(e) => setName(e)} />

                                <CustomTextInput label="Product code"
                                    placeholder="JSN34"
                                    type="text"
                                    require
                                    value={code}
                                    error={codeError}
                                    className="w-100"
                                    labelStyle="e-font-weight-500 e-text-raisin-black"
                                    onKeyPress={_handleSubmit}
                                    handleChange={(e) => setCode(e)} />

                                <CustomSelectBox label="Interior/Exterior"
                                    value={selectedCategory}
                                    options={props.categoryData.filter(item => item.value !== null)}
                                    // type={2}
                                    padding="11px 16px"
                                    className="e-modal-select e-bg-white e-border-radius-12"
                                    isSearchable={false}
                                    error={selectedCategoryError}
                                    selectChange={(value) => setSelectedCategory(value)}
                                />


                                <CustomSelectBox label="Category"
                                    value={selectedPremium}
                                    options={CATEGORY}
                                    // type={2}
                                    padding="11px 16px"
                                    className="e-modal-select e-bg-white e-border-radius-12"
                                    isSearchable={false}
                                    error={selectedPremiumError}
                                    selectChange={(value) => setSelectedPremium(value)}
                                />

                                <CustomSelectBox label="Innovation/Old"
                                    value={selectedInnovation}
                                    options={INNOVATION}
                                    // type={2}
                                    padding="11px 16px"
                                    className="e-modal-select e-bg-white e-border-radius-12"
                                    isSearchable={false}
                                    error={selectedInnovationError}
                                    selectChange={(value) => setSelectedInnovation(value)}
                                />

                                <CustomSelectBox label="Type"
                                    value={selectedType}
                                    options={TYPE}
                                    // type={2}
                                    padding="11px 16px"
                                    className="e-modal-select e-bg-white e-border-radius-12"
                                    isSearchable={false}
                                    error={selectedTypeError}
                                    selectChange={(value) => setSelectedType(value)}
                                />

                                <CustomTextInput label="Reward points per unit"
                                    placeholder="10"
                                    type="number"
                                    require
                                    value={point}
                                    error={pointError}
                                    className="w-100"
                                    labelStyle="e-font-weight-500 e-text-raisin-black"
                                    onKeyPress={_handleSubmit}
                                    handleChange={(e) => setPoint(e)} />

                                <CustomTextInput label="Size"
                                    placeholder="Enter size"
                                    type="number"
                                    require
                                    value={size}
                                    error={sizeError}
                                    className="w-100"
                                    labelStyle="e-font-weight-500 e-text-raisin-black"
                                    onKeyPress={_handleSubmit}
                                    handleChange={(e) => setSize(e)} />

                                {/* <CustomTextInput label="Size text"
                                    placeholder="Enter size text"
                                    type="text"
                                    require
                                    value={sizeUnit}
                                    error={sizeUnitError}
                                    className="w-100"
                                    labelStyle="e-font-weight-500 e-text-raisin-black"
                                    onKeyPress={_handleSubmit}
                                    handleChange={(e) => setSizeUnit(e)} /> */}
                            </>
                        }
                    </div>
                    <div className='modal-footer border-0 pt-0 px-4 pb-4'>
                        <div className='row w-100 g-3'>
                            <div className='col-6 ps-0'>
                                <SecondaryButton name="Cancel"
                                    className="w-100"
                                    onPress={_handleCloseModal} />
                            </div>
                            <div className='col-6 pe-0'>
                                <PrimaryButton name={props.buttonLabel}
                                    className="w-100"
                                    disabled={(props.type === 1 && file === null)}
                                    status={props.loader}
                                    onPress={_handleSubmit} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default memo(ManageProductModal);